/* ==================================================
  TOPへ戻るボタン
===================================================*/

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("a_backToTop");
  const chatBtn = document.querySelector(".js-custom-channel-button");

  // スクロールで表示制御
  function checkScroll() {
    if (window.scrollY > 300) {
      btn.classList.add("is-show");
      if(chatBtn) chatBtn.classList.remove("is-low");
    } else {
      btn.classList.remove("is-show");
      if(chatBtn) chatBtn.classList.add("is-low");
    }
  };

  // ① スクロールした時に判定を実行する
  window.addEventListener("scroll", checkScroll);

  // ② ページ読み込み完了時（リロード直後）にも1回だけ判定を実行する
  checkScroll();

  // クリックでトップへスムーススクロール
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
